import styled from "styled-components";
import { MainWrapper } from "@/lib/styles";

export const Container = styled(MainWrapper)`
  margin-top: 8rem;
  margin-bottom: 8rem;
  ${({ theme }) => theme.mediaQueries.laptop} {
    margin-top: 10rem;
    margin-bottom: 10rem;
  }
`;
